import type {
  ChangePasswordRequest,
  ProfileResponse,
  UpdateProfileRequest,
} from "@telecurb/shared";
import { api } from "./api";

export function getMyProfile(): Promise<ProfileResponse> {
  return api<ProfileResponse>("/api/v1/me/profile");
}

export function updateMyProfile(patch: UpdateProfileRequest): Promise<ProfileResponse> {
  return api<ProfileResponse>("/api/v1/me/profile", {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export function changeMyPassword(body: ChangePasswordRequest): Promise<void> {
  return api<void>("/api/v1/me/password", {
    method: "POST",
    body: JSON.stringify(body),
  });
}
